import React from 'react';
import Form from 'react-bootstrap/Form'
import { Space } from 'antd';
import ReqSosOutage from './ReqSosOutage';
import PreEDate from '../PreEFormFields/PreEDate';
import IPSLocationHeader from '../PreEFormFields/IPSLocationHeader';
import IPSLocations from '../PreEFormFields/IPSLocations';
import FormTitle from "./FormTitle";
import EnergizationStatus from "./EnergizationStatus";
import Spinner from "../../../components/Spinner";
import AttestedDrawingsModal from '../../../components/Viewer/OneLineDrawings/attestedDrawingModal';




const PreEFormFields = ({ ...props}) => {
    // Prevent form submission from checkbox clicks
    const handleFormSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Form submission is handled by explicit Save button clicks, not by form submit events
        return false;
    };

    return (
        <>
            <Spinner />
            <Form onSubmit={handleFormSubmit}>
              <Space direction="vertical">
                <FormTitle {...props}/>
                <PreEDate {...props}  />
                <EnergizationStatus {...props} />
                <ReqSosOutage {...props} />
                <AttestedDrawingsModal {...props}/>
                <IPSLocationHeader />
                <IPSLocations {...props}/>
              </Space>
            </Form>
        </>
    );
};

export default PreEFormFields;